var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.25C4.5 2.80228 4.05229 3.25 3.5 3.25C2.94772 3.25 2.5 2.80228 2.5 2.25M4.5 2.25C4.5 1.69772 4.05229 1.25 3.5 1.25C2.94772 1.25 2.5 1.69772 2.5 2.25M4.5 2.25H10.25M2.5 2.25H0.75M6.5 6.25C6.5 5.69772 6.94772 5.25 7.5 5.25C8.05228 5.25 8.5 5.69772 8.5 6.25M6.5 6.25C6.5 6.80228 6.94772 7.25 7.5 7.25C8.05228 7.25 8.5 6.80228 8.5 6.25M6.5 6.25L0.75 6.25M8.5 6.25H10.25",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a88e123f8c361fbb88cbb455b44c07ea.svg";
export { ForwardRef as ReactComponent };